import { IEventTelemetry } from '@microsoft/applicationinsights-web';
import { getTenantId } from 'src/Common/Models/StoreConstants';
import { UATConstants } from 'src/Common/Models/UATConstants';
import { useAppSelector } from 'src/Common/RTK/store';
import { appInsights } from 'src/Services/Insights';
import { TenantNames } from 'src/tenantConfig/interface';

export const useIsROBTemetryAction = () => {
  const tenantData = useAppSelector((state: any) => state.tenant?.tenantConfig);
  const tenantId = getTenantId();
  const tenantConfig = tenantData?.[tenantId];
  const tenantProvider = tenantConfig?.Tenant;
  return tenantProvider === TenantNames.MCAPSRoB;
};

export const getROBTemetetry = (
  name: string,
  userAction: string,
  raidid: string,
  statusCode: string
) => {
  const request: IEventTelemetry = {
    name: name,
  };
  const properties = {
    userAction: userAction,
    date: Date.now(),
    requestedUserName: sessionStorage.getItem(UATConstants.jwtUserAccountName),
    requestedUserAlias: sessionStorage.getItem(UATConstants.jwtUserAccountEmail),
    raidid: raidid,
    tenantid: getTenantId(),
    statusCode: statusCode,
  };
  appInsights.trackEvent(request, properties);
};

export const trackUserContextTenantAuth = (
  eventName: string,
  tenantAuthorizations: TenantAuthorization[],
  userFlight: UserFlight[],
  userHasRoleScope : boolean,
  requestedUserName: string,
  requestedUserAlias: string
) => {
  
  const request: IEventTelemetry = {
    name: eventName,
  };
  
  const safeStringify = (data: any) => {
    try {
      return JSON.stringify(data || []);
    } catch (error) {
      console.error('Serialization error:', error);
      return 'Serialization Error';
    }
  };

  const properties = {
    date: Date.now(),
    tenantAuthorizationsData: safeStringify(tenantAuthorizations),
    userFlightData: safeStringify(userFlight),
    userHasRoleScope: userHasRoleScope,
    requestedUserName: requestedUserName,
    requestedUserAlias: requestedUserAlias,
  };
  
  appInsights.trackEvent(request, properties);
};
